import React from 'react';
import T from 'i18n-react';
import Grid from '@material-ui/core/Grid';
import { AppDialog } from '../../core/Dialog/AppDialog';
import { withSnackbar } from 'notistack';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  subtitle: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 'bold',
  },
  lineImg: {
    width: '100%',
    maxWidth: 150,
  },
}));

const LineFriendRequestDialogContent = () => {
  const classes = useStyles();
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} className={classes.subtitle} component={Typography}>
        {T.translate('lineFriendRequest.openAccount')}
      </Grid>
      <Grid item xs={12} component={Typography}>
        {T.translate('lineFriendRequest.advantage')}
      </Grid>
      <Grid item xs={12} container justify="center">
        <Button
          component="a"
          href={process.env.LINE_TUTORIAL_OFFICIAL_DIRECT_URL}
          target="_blank"
          rel="noopener"
          disableRipple
          disableFocusRipple
          disableTouchRipple
        >
          <img
            src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png"
            className={classes.lineImg}
            alt="友達追加"
          />
        </Button>
      </Grid>
    </Grid>
  );
};

class LineFriendRequestDialog extends AppDialog {
  isTitleDisabled = () => true;

  actionButtonRenderer = () => undefined;

  getCancelButtonText = () => T.translate('close');

  getDialogProps = () => ({ maxWidth: 500 });

  getDialogContentProps = () => ({ style: { overflow: 'hidden' } });

  dialogContentRenderer = (): React.ReactNode => (
    <LineFriendRequestDialogContent />
  );

  handleAccept(event) {
    this.props.onAccept?.(event);
  }
}

LineFriendRequestDialog.propTypes = AppDialog.propTypes;

export default withSnackbar(LineFriendRequestDialog);
